import {
  ChipCellComponent,
  KebabMenuCellConfig,
  WcgChipType,
  WcgTableRow,
} from '@wcg/frontend-framework';
import { DOCUMENT_TYPES_COLUMNS } from '../constants';
import { DocumentTypeCallbacks, DocumentTypesData } from '../types';

export function transformDocumentTypesData(
  data: DocumentTypesData[],
  callbacks?: Map<string, DocumentTypeCallbacks>,
): WcgTableRow[] {
  if (!DOCUMENT_TYPES_COLUMNS?.length) return [];

  return data.map((item, index) => ({
    ...getActionCell(
      DOCUMENT_TYPES_COLUMNS[0].columnKey ?? '',
      item,
      index,
      callbacks!,
    ),
    ...DOCUMENT_TYPES_COLUMNS.slice(1).reduce(
      (acc, col) => {
        if (col.columnKey) {
          acc[col.columnKey] = getCellConfig(col.columnKey, item);
        }
        return acc;
      },
      {} as Record<string, unknown>,
    ),
  })) as WcgTableRow[];
}

function getCellConfig(key: string, item: DocumentTypesData) {
  const configMap: Record<string, unknown> = {
    is_active: {
      componentType: ChipCellComponent,
      componentConfig: {
        chipType: item.is_active ? WcgChipType.SUCCESS : WcgChipType.NEUTRAL,
      },
      cellData: item.is_active ? 'Enabled' : 'Disabled',
    },
    legacy_id: { componentType: 'default', cellData: item.legacy_id ?? '' },
    name: { componentType: 'default', cellData: item.name },
  };
  return configMap[key] || {};
}

function getActionCell(
  cellData: string,
  item: DocumentTypesData,
  index: number,
  callbacks: Map<string, DocumentTypeCallbacks>,
) {
  const componentConfig: KebabMenuCellConfig = {
    columnKey: 'actions',
    eventParams: item,
    icon: 'more_horiz',
    menuItems: [
      {
        callback: callbacks?.get('edit')!.callback,
        title: 'Edit',
        disabled: callbacks?.get('edit')!.disabled,
      },
      {
        callback: callbacks?.get('delete')!.callback,
        title: 'Delete',
        disabled: callbacks?.get('delete')!.disabled,
      },
    ],
    rowIndex: index,
  };
  return {
    [cellData]: {
      cellData: 'N/A',
      componentConfig: componentConfig,
      componentType: 'kebabmenu',
    },
  };
}
